import { useQuery } from "react-query";
import { lineManagerDataLoader } from "../utils/queries";

const useGetLineManager = () =>
  useQuery([lineManagerDataLoader.uniqueKey], lineManagerDataLoader.loader, {
    refetchOnWindowFocus: false,
    retry: false,
  });

export default useGetLineManager;
